// src/api_scripts/createDesktopProfile.js
import { createApiClient } from "../apiClient";

const createDesktopProfile = async (desktopProfileData, orgId, accessToken, setProgress) => {
  const { name } = desktopProfileData.name;
  setProgress((prev) => [
    ...prev,
    { type: 'info', message: `Attempting to create Desktop Profile: "${name}"...`, timestamp: new Date().toLocaleTimeString() }
  ]);

  // API endpoint for creating a new Desktop Profile
  const relativeUri = `organization/${orgId}/agent-profile`;

  try {
    const apiClient = createApiClient(accessToken);
    const response = await apiClient.post(relativeUri, desktopProfileData);

    const newDesktopProfile = response.data; // The API returns the created resource directly

    console.log("Create Desktop Profile API Response Data:", newDesktopProfile);

    setProgress((prev) => [
      ...prev,
      { type: 'success', message: `Successfully created Desktop Profile "${name}" (ID: ${newDesktopProfile.id}).`, timestamp: new Date().toLocaleTimeString() }
    ]);

    return newDesktopProfile.id; // Return the created Desktop Profile object (includes its ID)

  } catch (error) {
    console.error(`Error creating Desktop Profile "${name}":`, error);

    let errorMessage = `Error creating Desktop Profile "${name}": ${error.message || String(error)}`;

    if (error.response && error.response.data) {
      if (error.response.data.error && error.response.data.error.reason) {
        errorMessage += ` (Reason: ${error.response.data.error.reason})`;
      } else if (error.response.data.message) {
        errorMessage += ` (Detail: ${error.response.data.message})`;
      } else if (typeof error.response.data === 'string') {
        errorMessage += ` (Response: ${error.response.data})`;
      }
    }

    setProgress((prev) => [
      ...prev,
      { type: 'error', message: errorMessage, timestamp: new Date().toLocaleTimeString() }
    ]);
    throw error;
  }
};

export default createDesktopProfile;
